export const setLocalStorageItem = (keyItem, value) => {
  localStorage[keyItem] = JSON.stringify(value);
};
